import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react';

import { Image, Text, Box } from '@chakra-ui/react';
import { staticURL } from 'core/url';
import { SystemCategory } from 'constants/global';
import { RFQEmptyIcon, QuotesEmptyIcon, OrderEmptyIcon } from 'icons';
import { OperateChecker } from 'apps/components';
import { useRouterStore } from 'apps/hooks';
import { Button, EmptyText, EmptyWrapper } from 'components';
import { themes } from 'styles/themes/wikifactoryNew';
import { clientStore } from 'apps/client/app';

export const EmptyConnTable = observer(
  ({
    height,
    contentName,
    conn,
  }: {
    height: number;
    contentName: string;
    conn: any;
  }) => {
    const routerStore = useRouterStore();
    let imageHeight = 200;
    const [wrapperWidth, setWrapperWidth] = useState<number>();
    const emptyWrapperStyle = wrapperWidth
      ? { width: wrapperWidth }
      : { width: '100%' };

    useEffect(() => {
      const resetWrapperWidth = () => {
        const wrapperDom = document.getElementById('tableWrapper');
        if (wrapperDom) {
          setWrapperWidth(wrapperDom.offsetWidth);
        }
      };

      resetWrapperWidth();
      window.addEventListener('resize', resetWrapperWidth);

      return () => {
        window.removeEventListener('resize', resetWrapperWidth);
      };
    }, []);
    if (height - 40 <= imageHeight) imageHeight = Math.max(height - 40, 80);
    // Add condition based on applued Fiters instead of localFilters in the URL
    let contentElement = (
      <Box>
        <Text as='small' fontSize='md' color='black'>
          No {contentName} match Filters.
        </Text>
        <Button
          display='block'
          ml='12'
          mt='6'
          variant='outline'
          borderRadius='20px'
          fontWeight='regular'
          color='blue'
          size='sm'
          onClick={() => {
            conn.ClearFilters();
            conn.ApplyFilters();
          }}
        >
          Clear Filters
        </Button>
      </Box>
    );

    if (conn?.appliedFilters && Object.keys(conn.appliedFilters).length === 0) {
      contentElement = (
        <Text as='small' fontSize='md' color='black'>
          No {contentName} yet.
        </Text>
      );
    }

    const emptyText = `No ${contentName} yet.`;
    const disabled =
      (!clientStore.isBusinessPlanOfCurrentSpace ||
        clientStore.isInProfileSpace) &&
      CI === 'false';

    // new empty placeholder
    const placeholderMap: Record<string, any> = {
      [SystemCategory.RFQs]: (
        <EmptyWrapper style={emptyWrapperStyle}>
          <RFQEmptyIcon />
          <EmptyText text={emptyText} />
          <OperateChecker type='canCreateIn'>
            <>
              {!disabled && (
                <Button
                  outline
                  size='small'
                  text='New RFQ'
                  style={{
                    fontSize: 16,
                    borderColor: themes.color.wfBlack,
                  }}
                  variant='tertiary'
                  onClick={() =>
                    routerStore.navigate('workspace.make-part', {
                      spacePath: clientStore.slugFromRouteOrSpace,
                    })
                  }
                  data-testid='new-rfq-button'
                />
              )}
              {/* <p className='mt-4 cursor-pointer text-sm text-black'>
                Learn more about RFQ on Wikifactory?
              </p> */}
            </>
          </OperateChecker>
        </EmptyWrapper>
      ),
      [SystemCategory.Quotes]: (
        <EmptyWrapper style={emptyWrapperStyle}>
          <QuotesEmptyIcon />
          <EmptyText text={emptyText} />
          {/* <p className='cursor-pointer text-sm text-black'>
            Learn more about Quotes
          </p> */}
        </EmptyWrapper>
      ),
      [SystemCategory.Orders]: (
        <EmptyWrapper style={emptyWrapperStyle}>
          <OrderEmptyIcon />
          <EmptyText text={emptyText} />
          {/* <p className='cursor-pointer text-sm text-black'>
            Learn more Orders on Wikifactory
          </p> */}
        </EmptyWrapper>
      ),
    };

    return (
      placeholderMap[contentName] || (
        <Box minHeight={height} position='relative'>
          <Box
            position='absolute'
            left={0}
            right={0}
            bottom={0}
            top={0}
            display='flex'
            alignItems='center'
            justifyContent='center'
            flexDirection='row'
            bg='gray.50'
          >
            <Image
              mr={6}
              src={staticURL('/assets/banners/trimmed/005.svg')}
              height={`${imageHeight}px`}
            />
            {contentElement}
          </Box>
        </Box>
      )
    );
  },
);
